import { Suspense, useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider } from "@material-tailwind/react";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { Toaster } from "react-hot-toast";
import { Provider } from "react-redux";
import LayoutContainer from "../views/layout/containers/LayoutContainer";
import ErrorToast from "../views/layout/components/ErrorToast";
import DarkModeHandler from "../views/layout/components/DarkModeHandler";
import { store } from "../store/store";
import { config } from "../config";

const customTheme = {
	button: {
		defaultProps: {
			color: "blue"
		},
		styles: {
			variants: {
				filled: {
					blue: {
						background: "bg-primary",
						color: "text-white",
						shadow: "shadow-md shadow-primary/20",
						hover: "hover:shadow-lg hover:shadow-primary/40"
					}
				},
				gradient: {
					blue: {
						background: "bg-gradient-to-tr from-primary to-primary-400",
						color: "text-white",
						shadow: "shadow-md shadow-primary/20",
						hover: "hover:shadow-lg hover:shadow-primary/40"
					}
				},
				outlined: {
					blue: {
						border: "border border-primary dark:border-primary-300",
						color: "text-primary dark:text-primary-300",
						hover: "hover:opacity-75"
					}
				}
			}
		}
	},
	card: {
		styles: {
			base: {
				initial: {
					bg: "bg-white"
				}
			}
		}
	},
	list: {
		styles: {
			base: {
				item: {
					selected: {
						bg: "bg-primary/10 dark:bg-primary/20",
						color: "text-primary dark:text-primary-300"
					}
				}
			}
		}
	}
};

const App = () => {
	useEffect(() => {
		const handler = (event: MessageEvent) => {
			if (event.data?.type === "open-url" && event.data?.url) {
				window.open(event.data.url, "_blank");
			}
		};
		window.addEventListener("message", handler);
		return () => window.removeEventListener("message", handler);
	}, []);

	return (
		<div className="app">
			<Suspense fallback={<div>Loading...</div>}>
				<GoogleOAuthProvider clientId={config.googleClientId}>
					<BrowserRouter>
						<ThemeProvider value={customTheme}>
							<Provider store={store}>
								<Toaster position="bottom-center" />
								<ErrorToast />
								<DarkModeHandler />
								<LayoutContainer />
							</Provider>
						</ThemeProvider>
					</BrowserRouter>
				</GoogleOAuthProvider>
			</Suspense>
		</div>
	);
};

export default App;
